import { Check, Flag, Heart } from 'lucide-react';
import { useT } from '../hooks/useT';

/** Uitleg van de kaartsymbolen (zelfde vormen en kleuren als op de kaart, zie utils/mapKleuren.ts). */
export function Legenda() {
  const { t } = useT();
  return (
    <ul className="space-y-2 text-sm">
      <li className="flex items-center gap-3">
        <span className="h-5 w-5 shrink-0 rounded-full border-[3px] border-indigo-700 bg-slate-50 dark:border-indigo-400 dark:bg-slate-900" aria-hidden />
        {t('legendaNiet')}
      </li>
      <li className="flex items-center gap-3">
        <span className="grid h-5 w-5 shrink-0 place-items-center rounded-full bg-emerald-700 text-white dark:bg-emerald-500" aria-hidden>
          <Check size={12} strokeWidth={4} />
        </span>
        {t('bezocht')}
      </li>
      <li className="flex items-center gap-3">
        <span className="grid h-5 w-5 shrink-0 place-items-center rounded-full bg-amber-700 text-white" aria-hidden>
          <Flag size={11} strokeWidth={3} />
        </span>
        {t('wens')}
      </li>
      <li className="flex items-center gap-3">
        <span className="grid h-5 w-5 shrink-0 place-items-center rounded-full bg-rose-700 text-white" aria-hidden>
          <Heart size={11} strokeWidth={3} />
        </span>
        {t('fav')}
      </li>
      <li className="flex items-center gap-3">
        <svg width="20" height="20" viewBox="0 0 20 20" aria-hidden className="shrink-0">
          <circle cx="10" cy="10" r="8" fill="none" strokeWidth="3.5" className="stroke-indigo-700 dark:stroke-indigo-400" />
          <circle cx="10" cy="10" r="8" fill="none" strokeWidth="3.5" strokeDasharray="17 50" transform="rotate(-90 10 10)" className="stroke-emerald-700 dark:stroke-emerald-500" />
        </svg>
        {t('legendaGroep')}
      </li>
    </ul>
  );
}
